import { ReactNode } from "react";

import ErrorBoundary from "common/components/ErrorBoundary";

import GlobalErrorPage from "./GlobalErrorPage";

type GlobalErrorBoundaryProps = { children: ReactNode };

/**
 * This should be the first and last thing rendered in the react tree as a final catch-all for any errors.
 * Reports to Datadog RUM when enabled.
 */
const GlobalErrorBoundary = ({ children }: GlobalErrorBoundaryProps) => {
  return (
    <ErrorBoundary fallback={<GlobalErrorPage />} context={{ source: "GlobalErrorBoundary" }}>
      {children}
    </ErrorBoundary>
  );
};

export default GlobalErrorBoundary;
